import { AppFormsContext } from 'global/cnr/contexts/AppFormsContext';
import UiSaveButtons from 'global/components/buttons/UiSaveButtons';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import WrapperVertCols from 'global/wrappers/WrapperVertCols';
import { useContext, useState } from 'react';
import Wrapper, { wrapperTypes } from '../../../global/wrappers/Wrapper';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import GolfCourseFetch from '../elements/GolfCourseFetch';
import { useGolf } from '../useHelpers/useGolf';
import { useColors } from 'global/cnr/contexts/useHelpers/useColors';

/** Create the Form structure for a Golf Tournament */
const CreateGolfCourse = () => {

  const { handleUpdate_golfCourse, updating } = useGolf()
  const { getSplitColorStyles } = useColors()

  // appFormsContext
  const appFormsContext = useContext(AppFormsContext);
  const { appForms_state } = appFormsContext ?? {}
  const { appForms } = appForms_state ?? {}

  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states: states_golf } = golfParent_contexts ?? {}
  const { golfEvent_state } = states_golf ?? {}
  const { golfCourses } = golfEvent_state ?? {}

  const [selectedGolfCourse, setSelectedGolfCourse] = useState()
  const [selectedTeeBox, setSelectedTeeBox] = useState()
  const [selectedTeeBoxAlt, setSelectedTeeBoxAlt] = useState()
  const [selectedHole, setSelectedHole] = useState()
  const [selectedHoleAlt, setSelectedHoleAlt] = useState()
  const [showAddNew, setShowAddNew] = useState()

  const handleUpdateHoles = () => {
    handleUpdate_golfCourse({ currentGolfCourse: selectedGolfCourse })
  }

  const handleSelectedHoleAlt = (hole) => {
    const _selectedGolfCourse = _.cloneDeep(selectedGolfCourse)
    const altHoleDistance = hole?.[selectedTeeBoxAlt?.name]
    _selectedGolfCourse.holes[hole.key][selectedTeeBox.name] = altHoleDistance
    _selectedGolfCourse.holes[hole.key][`_${selectedTeeBox.name}`] = selectedTeeBoxAlt?.name
    setSelectedHoleAlt(hole)
    setSelectedGolfCourse(_selectedGolfCourse)
    console.log('selectedGolfCourse', _selectedGolfCourse)
  }

  const footer_gcs = () => {
    const oc = () => { setShowAddNew(!showAddNew) }
    const btns = []
    btns.push({ caption: 'Add', oc: oc, color: 'blue', icon: 'arrow right' })
    return <UiSaveButtons others={btns} />
  }

  const footer_holes = () => {
    const oc = () => { handleUpdateHoles() }
    const btns = []
    btns.push({ caption: 'Update', oc: oc, color: 'blue', icon: 'arrow right' })
    return <UiSaveButtons others={btns} />
  }

  const wrapper_generic = (header, content, footer) => <Wrapper
    header={header}
    content={content}
    footer={footer}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
    updating={updating}
  />

  const ims_gcs = () => {
    const oc = (item) => { setSelectedGolfCourse(item) }
    const fnSub = (item) => { return item?.key }
    const gcs = _.fromPairs(
      _.sortBy(
        _.toPairs(golfCourses),
        ([key, course]) => course.name
      )
    )
    return <ItemMenuSquares
      menuItems={gcs}
      imsType={_imsTypes.inline}
      // fn_subContent={fnSub}
      onClick={oc} activeItem={selectedGolfCourse?.name}
    />
  }

  const ims_holes = () => {
    const oc = (item) => { setSelectedHole(item) }
    const fnSub = (item) => {
      if (selectedTeeBox) {
        const altName = `_${selectedTeeBox?.name}`
        return <div>
          <div>{`${selectedTeeBox?.name}: ${item?.[selectedTeeBox?.name]}`}</div>
          {item?.[altName] && <div style={{ ...getSplitColorStyles({ backgroundColor: item?.[altName] }) }}>{`${item?.[altName]}`}</div>}
        </div>
      }
    }
    const fnAlt = (item) => {
      return <div>{`${item.par}/${item.handicap}`}</div>
    }
    return <ItemMenuSquares menuItems={selectedGolfCourse?.holes} imsType={_imsTypes.inline} onClick={oc} iconItem={'flag outline'} fn_altContent={fnAlt} fn_subContent={fnSub} activeItem={selectedHole?.key} />
  }

  const ims_holes_alt = () => {
    const oc = (item) => { handleSelectedHoleAlt(item) }
    const fnSub = (item) => {
      if (selectedTeeBoxAlt) {
        return `${selectedTeeBoxAlt?.name}: ${item?.[selectedTeeBoxAlt?.name]}`
      }
    }
    const fnAlt = (item) => {
      return <div>{`${item.par}/${item.handicap}`}</div>
    }
    return <ItemMenuSquares menuItems={selectedGolfCourse?.holes} imsType={_imsTypes.inline} onClick={oc} iconItem={'flag outline'} fn_altContent={fnAlt} fn_subContent={fnSub} activeItem={selectedHoleAlt?.key} />
  }

  const ims_teeboxes = () => {
    const oc = (item) => { setSelectedTeeBox(item) }
    const fnAlt = (item) => {
      return <div>{`${item.slope}/${item.rating}`}</div>
    }
    return <ItemMenuSquares menuItems={_.sortBy(selectedGolfCourse?.teeBoxes, 'name')} imsType={_imsTypes.inline} onClick={oc} iconItem={'box'} fn_altContent={fnAlt} activeItem={selectedTeeBox?.name} />
  }

  const ims_teeboxes_alt = () => {
    const oc = (item) => { setSelectedTeeBoxAlt(item) }
    const fnAlt = (item) => {
      return <div>{`${item.slope}/${item.rating}`}</div>
    }
    return <ItemMenuSquares menuItems={_.sortBy(selectedGolfCourse?.teeBoxes, 'name')} imsType={_imsTypes.inline} onClick={oc} iconItem={'box'} fn_altContent={fnAlt} activeItem={selectedTeeBoxAlt?.name} />
  }

  const wvc_gt = () => <WrapperVertCols mvc={showAddNew ? 6 : 5}  >
    {wrapper_generic('Golf Courses', ims_gcs(), footer_gcs())}
    {wrapper_generic('Teeboxes', ims_teeboxes())}
    {wrapper_generic('Holes', ims_holes(), footer_holes())}
    {wrapper_generic('Teeboxes Alt', ims_teeboxes_alt())}
    {wrapper_generic('Holes Alt', ims_holes_alt())}
    {showAddNew && wrapper_generic('New Course', <GolfCourseFetch />,)}
  </WrapperVertCols>

  return wvc_gt()

}

export default CreateGolfCourse